<div class="app-account-header">
  <img src="assets/icons/icon-account.svg" alt="">
  <div class="app-user-name">
    {{ userService.email }}
  </div>
  <div class="app-user-id" *ngIf="customerDataService.customerData?.customerNumber">
    Kundennummer: {{customerDataService.customerData?.customerNumber}}
  </div>
</div>
